// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604291011/js/" + chunkId + "." + {"44":"de267441","225":"4f8782a1","481":"7946248b","486":"af303b0b","770":"bb0e947f"}[chunkId] + ".0.06658401225919164.chunk.js";
};